// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rz-6";
export var imgContainer = "_rz-3";
export var menuIcon = "_rz-5";
export var pillWrapper = "_rz-2";
export var pillsContainer = "_rz-1";
export var subscriptionCard = "_rz-0";
export var subscriptionLogo = "_rz-4";